import { createContext, useContext } from 'react'
import type { ScheduleMarker, UserProfile } from '../../../types'

/** Everything the grid, the FABs and settings need about schedule lines. */
export interface ScheduleMarkersValue {
  /** Signed-in viewer's own lines on the selected day, sorted by time. */
  own: ScheduleMarker[]
  /** Lines friends shared with the viewer on the selected day, minus hidden/blocked ones. */
  shared: ScheduleMarker[]
  /** Shared lines at this event the viewer hid one by one. */
  hiddenLines: ScheduleMarker[]
  hiddenAuthorIds: string[]
  profiles: Record<string, UserProfile>
  openCreate: () => void
  openEdit: (marker: ScheduleMarker) => void
  move: (marker: ScheduleMarker, minutes: number) => void
  hideLine: (marker: ScheduleMarker) => void
  hideAuthor: (uid: string) => void
  showLine: (marker: ScheduleMarker) => void
  showAuthor: (uid: string) => void
}

const EMPTY: ScheduleMarkersValue = {
  own: [],
  shared: [],
  hiddenLines: [],
  hiddenAuthorIds: [],
  profiles: {},
  openCreate: () => {},
  openEdit: () => {},
  move: () => {},
  hideLine: () => {},
  hideAuthor: () => {},
  showLine: () => {},
  showAuthor: () => {},
}

export const ScheduleMarkersContext = createContext<ScheduleMarkersValue>(EMPTY)

export function useScheduleMarkersContext() {
  return useContext(ScheduleMarkersContext)
}
